function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m379.03125 256c0 82.472656-66.859375 149.332031-149.332031 149.332031-82.476563 0-149.332031-66.859375-149.332031-149.332031s66.855468-149.332031 149.332031-149.332031c82.472656 0 149.332031 66.859375 149.332031 149.332031zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m229.699219 74.667969c11.796875 0 21.332031-9.558594 21.332031-21.335938v-32c0-11.773437-9.535156-21.332031-21.332031-21.332031s-21.332031 9.558594-21.332031 21.332031v32c0 11.777344 9.535156 21.335938 21.332031 21.335938zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m60.246094 133.523438-27.730469-16c-10.21875-5.886719-23.253906-2.386719-29.140625 7.808593-5.890625 10.199219-2.390625 23.253907 7.804688 29.144531l27.734374 16c3.351563 1.9375 7.019532 2.855469 10.644532 2.855469 7.382812 0 14.550781-3.816406 18.496094-10.664062 5.890624-10.21875 2.390624-23.253907-7.808594-29.144531zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m448.214844 357.523438-27.730469-16c-10.199219-5.886719-23.253906-2.386719-29.144531 7.808593-5.886719 10.199219-2.386719 23.253907 7.808594 29.144531l27.734374 16c3.347657 1.9375 7.019532 2.855469 10.644532 2.855469 7.382812 0 14.550781-3.816406 18.496094-10.664062 5.910156-10.21875 2.410156-23.253907-7.808594-29.144531zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m38.914062 341.523438-27.734374 16c-10.21875 5.890624-13.714844 18.945312-7.804688 29.144531 3.964844 6.847656 11.113281 10.664062 18.496094 10.664062 3.625 0 7.292968-.917969 10.644531-2.855469l27.730469-16c10.21875-5.890624 13.71875-18.945312 7.808594-29.144531-5.90625-10.21875-18.984376-13.695312-29.140626-7.808593zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m409.835938 173.332031c3.628906 0 7.296874-.917969 10.648437-2.855469l27.730469-16c10.21875-5.890624 13.71875-18.945312 7.808594-29.144531-5.910157-10.21875-18.984376-13.714843-29.140626-7.808593l-27.734374 16c-10.21875 5.890624-13.714844 18.945312-7.808594 29.144531 3.96875 6.847656 11.136718 10.664062 18.496094 10.664062zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m229.699219 437.332031c-11.796875 0-21.332031 9.558594-21.332031 21.335938v32c0 11.773437 9.535156 21.332031 21.332031 21.332031s21.332031-9.558594 21.332031-21.332031v-32c0-11.777344-9.535156-21.335938-21.332031-21.335938zm0 0"
});

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-26 0 511 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.48b3849d.svg";
export { ForwardRef as ReactComponent };